module.exports = __webpack_public_path__ + "img/upArrowLQS.68576559.svg";